/**
 * @file
 * A JavaScript file containing the how-to functionality
 */

(function (Drupal, $) {
  Drupal.behaviors.howto = {
    attach: function (context) {
      "use strict";

      $(".how-to .persona-type-popup-form .form-submit").on(
        "mousedown touchstart",
        function () {
          window.localStorage.setItem("changed-persona", "changed");
        }
      );

      let isProcessing = false;
      $(document).off('ajaxComplete.howtoAjaxSuccess').on('ajaxComplete.howtoAjaxSuccess', function(event, xhr, settings) {
        // Prevent multiple executions
        if (!isProcessing) {
          isProcessing = true;
          setTimeout(function() {
            if (
              drupalSettings &&
              drupalSettings.views &&
              drupalSettings.views.ajaxViews
            ) {
              var ajaxViews = drupalSettings.views.ajaxViews;
              Object.keys(ajaxViews || {}).forEach(function (i) {
                if (
                  ajaxViews[i]["view_name"] == "how_to_invest" &&
                  ajaxViews[i]["view_display_id"] == "how_to_invest"
                ) {
                  updateHashFromSelect();
                  openDetails();
                }
              });
            }
            // Reset the flag
            isProcessing = false;
          }, 100);
        }
      });
    },
  };

  function updateHashFromSelect() {
    var fund = $(".nice-select")
      .siblings("select")
      .find("option:selected")
      .data("fund-id");

    fund = "#" + fund;
    if (history.pushState) {
      history.pushState(null, null, fund);
    } else {
      location.hash = fund;
    }
  }

  function openDetails(tab) {
    var hash = window.location.hash;
    var views = [
      "/invest",
      "/uk/invest",
      "/us/invest",
      "/aus/invest",
      "/eur/invest",
    ];
    var invest = views.indexOf(window.location.pathname) != -1;
    if (invest && hash) {
      $("#how-to-details").addClass("active");
      if (window.localStorage.getItem("changed-persona") == "changed") {
        var viewTop = $("#how-to-details");
        window.localStorage.setItem("changed-persona", "unchanged");
      } else {
        var viewTop = $(".nice-select").closest(".views-element-container");
      }
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $(viewTop).offset().top - 150,
        },
        1000
      );
    }
  }
})(Drupal, jQuery);
